export const useModalStore = defineStore('modal', {
  state: () => {
    return {
      types: {
        info: {
          submitButtonType: 'primary',
          icon: 'info-circle',
          iconColor: 'text-blue-500',
          iconBgColor: 'bg-blue-50',
        },
        success: {
          submitButtonType: 'primary',
          icon: 'check-circle-broken',
          iconColor: 'text-green-500',
          iconBgColor: 'bg-green-50',
        },
        warning: {
          submitButtonType: 'primary',
          icon: 'alert-triangle',
          iconColor: 'text-orange-500',
          iconBgColor: 'bg-orange-50',
        },
        danger: {
          submitButtonType: 'danger',
          icon: 'trash-01',
          iconColor: 'text-red-500',
          iconBgColor: 'bg-red-50',
        },
      },

      modal: {
        isOpen: false,
        type: null,
        title: null,
        description: null,
        bodyComponent: null,
        icon: null,
        submitButtonType: null,
        submitButtonText: null,
        cancelButtonText: null,
        onSubmit: () => {},
        onCancel: () => {},
      },

      defaults: {
        title: null,
        description: null,
        bodyComponent: null,
        onSubmit: () => {},
        onCancel: () => {},
        submitButtonText: useT('ds.confirm'),
        cancelButtonText: useT('ds.cancel'),
      },
    };
  },

  actions: {
    open(payload = {}) {
      this.modal.isOpen = true;
      this.modal = {
        ...this.modal,
        ...this.defaults,
        ...(this.types?.[payload.type] ?? {}),
        ...payload,
      };
    },

    close() {
      this.modal.isOpen = false;
    },
  },
});
